import React, { Component } from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";

import { fetchDropdown } from "../../../actions/actionCreators";

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from "../../common/form/FieldHelper";

  class CustomTabDropdown extends Component {
    render() {
      const {
        form,
        multiple,
        name,
        onPostChange,
        searchFn,
        searchParams,
        preload = true,
      } = this.props;

      return (
        <div className="field">
          <Field
            {...this.props}
            component={
              multiple ? renderSearchMultipleDropdown : renderSearchDropDown
            }
            dropdownType="custom_tab"
            formId={form}
            name={name}
            onPostChange={onPostChange}
            preload={preload}
            searchFn={searchFn}
            searchParams={{
              ...searchParams,
            }}
            type="custom_tab"
            valueField="id"
          />
        </div>
      );
    }
  };

export default connect(null, { searchFn: fetchDropdown })(CustomTabDropdown);
